import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './PageHeader.module.scss'

/**
 * Заголовок страницы — единый стиль для всех страниц приложения.
 *   <PageHeader
 *     title="Расписание"
 *     subtitle="Группы, аудитории, нагрузка преподавателей"
 *     actions={<UnvButton variant="primary" iconLeft="plus">Добавить</UnvButton>}
 *     breadcrumbs={[{ label: 'Главная', to: '/' }, { label: 'Расписание' }]}
 *   />
 */
const PageHeader = ({
  title,
  subtitle,
  actions,
  breadcrumbs,
  icon,
  className = '',
}) => {
  const { t } = useTranslation('common')
  return (
    <header className={`${styles.header} ${className}`}>
      {breadcrumbs && breadcrumbs.length > 0 && (
        <nav className={styles.breadcrumbs} aria-label={t('auto.unvui_pageheader.breadcrumbs', 'Хлебные крошки')}>
          {breadcrumbs.map((b, i) => (
            <React.Fragment key={i}>
              {b.to ? (
                <a href={b.to} className={styles.crumbLink}>{b.label}</a>
              ) : (
                <span className={styles.crumbCurrent} aria-current="page">{b.label}</span>
              )}
              {i < breadcrumbs.length - 1 && <span className={styles.crumbSep} aria-hidden="true">/</span>}
            </React.Fragment>
          ))}
        </nav>
      )}
      <div className={styles.row}>
        <div className={styles.titleBlock}>
          {icon && <span className={styles.icon}>{icon}</span>}
          <div>
            <h1 className={styles.title}>{title}</h1>
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
    </header>
  )
}

export default PageHeader
